module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dl-call"
  }, [_c('div', {
    staticClass: "dl-wrap"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "item client"
  }, [_c('a', {
    attrs: {
      "href": 'https://images.huoxingy.com/callClient/' + _vm.curStoreId + '.zip'
    }
  }, [_vm._v("客户端下载")])]), _vm._v(" "), _c('div', {
    staticClass: "item service"
  }, [_c('a', {
    attrs: {
      "href": 'https://images.huoxingy.com/service/' + _vm.curStoreId + '.zip'
    }
  }, [_vm._v("服务端(Win7/Win10)下载")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1c9f0ceb","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/callAndReward/dlCall/dlCall.vue
// module id = 929
// module chunks = 1